import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import bcrypt from "bcryptjs";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      // Look up admin by email (using email as document ID)
      const adminDocRef = doc(db, "admins", email);
      const adminSnapshot = await getDoc(adminDocRef);

      if (!adminSnapshot.exists) {
        throw new Error("Invalid email or password");
      }

      const adminData = adminSnapshot.data();

      // Verify password against stored hash
      const passwordMatch = await bcrypt.compare(password, adminData.passwordHash);
      if (!passwordMatch) {
        throw new Error("Invalid email or password");
      }

      // Save admin info locally
      localStorage.setItem("adminInfo", JSON.stringify({
        uid: adminData.email,
        email: adminData.email,
        name: adminData.displayName || adminData.email,
        role: adminData.role || "admin",
      }));

      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-gray-900 to-gray-800 p-4">
      <div className="bg-gray-800 p-10 rounded-2xl w-full max-w-md shadow-2xl border border-gray-700">
        <div className="flex justify-center mb-4">
          <div className="bg-cyan-500 p-4 rounded-full shadow-lg">
            <FiLock className="text-white w-6 h-6" />
          </div>
        </div>

        <h1 className="text-3xl font-bold mb-6 text-center text-cyan-400 tracking-wide">
          Admin Login
        </h1>

        {error && (
          <p className="text-red-500 mb-4 text-center font-medium">{error}</p>
        )}

        <div className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 rounded-xl bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:bg-gray-600 transition"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 rounded-xl bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:bg-gray-600 transition"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          onClick={handleLogin}
          className="w-full mt-6 bg-cyan-500 hover:bg-cyan-600 py-3 rounded-xl font-bold text-white shadow-md transition duration-200 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="text-gray-400 mt-4 text-center text-sm">
          Enter your admin credentials to continue
        </p>
      </div>
    </div>
  );
}